import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'

import { useApi } from '@tabeeb/modules/shared/utils/API/hooks'
import { CertificatesQueryKeys } from '@tabeeb/modules/certificates/queries'

export interface UseApprovedCertificateTypesProps {
  userGuid?: string
}

const useApprovedCertificateTypes = ({ userGuid }: UseApprovedCertificateTypesProps) => {
  const { certificateServiceApi: api } = useApi()

  const approvedCertificateTypeIdsQuery = useQuery({
    queryKey: [CertificatesQueryKeys.CertificateTypes, 'approved', userGuid],
    queryFn: () => api.certificateTypes.getApprovedTypeIdsByUserGuidAsync(userGuid!),
    enabled: !!userGuid,
  })

  return useMemo(
    () => ({
      approvedCertificateTypeIds: approvedCertificateTypeIdsQuery.data ?? [],
      loading: approvedCertificateTypeIdsQuery.isLoading,
    }),
    [approvedCertificateTypeIdsQuery.data, approvedCertificateTypeIdsQuery.isLoading]
  )
}

export default useApprovedCertificateTypes
